import { useCurrentTenant, UserContext as getUserInfo } from '@qpr/client-library';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { isValidUrlPath } from '../utils/url-utils';
import LandingPage from './LandingPage';

export default () => {
  let theLandingUrl = getUserInfo().landingUrl || useCurrentTenant().landingUrl;
  if (theLandingUrl) {
    if (theLandingUrl.indexOf('?') > 0) {
      const pos = theLandingUrl.indexOf('?');
      const path = theLandingUrl.substring(0, pos);
      theLandingUrl = isValidUrlPath(path) ? `${path}${theLandingUrl.substring(pos)}` : '';
    } else {
      if (!isValidUrlPath(theLandingUrl)) theLandingUrl = '';
    }
    if (theLandingUrl) {
      if (theLandingUrl.startsWith('/')) theLandingUrl = theLandingUrl.substring(1);
      if (theLandingUrl.indexOf('?') < 0 && !theLandingUrl.endsWith('/'))
        theLandingUrl = `${theLandingUrl}/`;
      return <Redirect to={theLandingUrl} />;
    }
  }

  return <LandingPage />;
};
